import { Component, EventEmitter, Output } from '@angular/core';
import { GlobalSandbox } from '../../shared/sandbox/providers/global.sandbox';
import { IdSandbox } from '../../shared/sandbox/providers/id.sandbox';

@Component({
  selector: 'id3-id-upload',
  templateUrl: './id-upload.component.html',
  styleUrls: ['./id-upload.component.css'],
  providers: [GlobalSandbox, IdSandbox]
})
export class IdUploadComponent {

  constructor(public globalSandbox: GlobalSandbox, public idSandbox: IdSandbox) { }

  @Output() nextEvent = new EventEmitter<void>();
  @Output() previousEvent = new EventEmitter<void>();

  next(): void {
    this.nextEvent.emit();
  }

  previous(): void {
    this.previousEvent.emit();
  }

}
